var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// @ts-expect-error - TS2724 - '"react"' has no exported member named 'Element'. Did you mean 'CElement'?
import React from "react";
const PersonWithLabel = (_a) => {
    var { fullName, photo, label, className } = _a, otherProps = __rest(_a, ["fullName", "photo", "label", "className"]);
    return (_jsxs("div", Object.assign({}, otherProps, { className: "media align-items-center " + (className || ""), children: [photo, _jsxs("div", { className: "media-body ml-2", children: [_jsx("div", { children: _jsx("small", { className: "text-muted", children: label }) }), _jsx("div", { children: fullName })] })] })));
};
export default PersonWithLabel;
